import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NzHeaderComponent, NzLayoutModule } from 'ng-zorro-antd/layout';
import { FooterComponent } from '../../molecule/footer/footer.component';
// Removed drawer imports as they are now handled in the sidebar component
import { SidebarComponent } from '../../molecule/sidebar/sidebar.component';

@UntilDestroy()
@Component({
  selector: 'app-layout-alpha',
  templateUrl: './layout-alpha.component.html',
  styleUrls: ['./layout-alpha.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    NzHeaderComponent,
    NzLayoutModule,
    RouterModule,
    FooterComponent,
    SidebarComponent
  ]
})
export class LayoutAlphaComponent {
  isHovering = false;
  isMenuVisible = false;
  timeoutRef: any;
  
  constructor(private route: Router) {}

  get isHomePage(): boolean {
    return this.route && this.route.url.includes('home');
  }

  onMouseEnter() {
    clearTimeout(this.timeoutRef); // Clear existing timeout if any
    this.isHovering = true; // Remove 'fold' immediately on hover
  }

  onMouseLeave() {
    this.timeoutRef = setTimeout(() => {
      this.isHovering = false; // Add 'fold' back after 5 seconds
    }, 5000);
  }

  // Mobile sidebar methods moved to sidebar component

  openMenu() {
    this.isMenuVisible = true;
  }

  closeMenu() {
    this.isMenuVisible = false;
  }
}
